import { render, staticRenderFns } from "./MenuPermissions.vue?vue&type=template&id=acca5722&scoped=true"
import script from "./MenuPermissions.vue?vue&type=script&lang=js"
export * from "./MenuPermissions.vue?vue&type=script&lang=js"
import style0 from "./MenuPermissions.vue?vue&type=style&index=0&id=acca5722&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acca5722",
  null
  
)

export default component.exports